import {
  LineChart,
  Line,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Legend,
} from "recharts";

// 🔹 Tooltip (slightly improved color sync)
const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload?.length) {

    // ✅ remove duplicate entries (Area + Line)
    const unique = [];
    const seen = new Set();

    payload.forEach((p) => {
      if (!seen.has(p.dataKey)) {
        seen.add(p.dataKey);
        unique.push(p);
      }
    });

    return (
      <div className="bg-slate-800 text-white text-xs rounded-lg px-3 py-2 shadow-xl">
        <p className="font-semibold mb-1">{label}</p>

        {unique.map((p, i) => (
          <p key={i} style={{ color: p.color }}>
            {p.name}: {p.value}
          </p>
        ))}
      </div>
    );
  }
  return null;
};

export default function ProductWarrantyChart({ data }) {
  // 🔹 get dynamic product keys
  const productKeys = Array.from(
    new Set(
      data.flatMap((item) =>
        Object.keys(item).filter((key) => key !== "date")
      )
    )
  );

  // 🔹 dashboard color system (same as donut)
  const DASHBOARD_COLORS = [
    "#22d3ee", // cyan
    "#a78bfa", // purple
    "#34d399", // green
    "#60a5fa", // blue
    "#f472b6", // pink
  ];

  return (
    <div className="bg-white rounded-2xl p-5 shadow-sm border border-slate-100">
      {/* Header */}
      <div className="mb-3">
        <h3 className="text-sm font-semibold text-slate-800">
          Product Warranty Sales
        </h3>
        <p className="text-[11px] text-slate-400">
          Product-wise warranty sales trend
        </p>
      </div>

      {/* Chart */}
      <div style={{ height: 350 }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            
            {/* 🔥 Gradient defs */}
            <defs>
              {productKeys.map((key, index) => (
                <linearGradient
                  key={key}
                  id={`gradient-${key}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="0%"
                    stopColor={DASHBOARD_COLORS[index % DASHBOARD_COLORS.length]}
                    stopOpacity={0.25}
                  />
                  <stop
                    offset="100%"
                    stopColor={DASHBOARD_COLORS[index % DASHBOARD_COLORS.length]}
                    stopOpacity={0}
                  />
                </linearGradient>
              ))}

              {/* 🔥 ADD THIS SHADOW FILTER */}
              <filter id="lineShadow" x="-50%" y="-50%" width="200%" height="200%">
                <feDropShadow
                  dx="0"
                  dy="2"
                  stdDeviation="3"
                  floodColor="#000000"
                  floodOpacity="0.2"
                />
              </filter>
            </defs>

            {/* Grid */}
            <CartesianGrid
              stroke="#e5e7eb"
              strokeDasharray="3 3"
              vertical={false}
            />

            {/* Axes */}
            <XAxis
              dataKey="date"
              interval={0}
              tick={{ fontSize: 10 }}
              angle={0}
              textAnchor="middle"
              tickFormatter={(value) =>
                String(new Date(value).getDate()).padStart(2, "0")
              }
            />
            <YAxis tick={{ fontSize: 10 }} allowDecimals={false} />

            {/* Tooltip + Legend */}
            <Tooltip content={<CustomTooltip />} />
            <Legend />

            {/* 🔥 Area (gradient fill) */}
            {productKeys.map((key, index) => (
              <Area
                  key={`area-${key}`}
                  type="monotone"
                  dataKey={key}
                  stroke="none"
                  fill={`url(#gradient-${key})`}
                  legendType="none"   // 🔥 ADD THIS
                />
            ))}

            {/* 🔥 Lines (smooth modern style) */}
            {productKeys.map((key, index) => (
              <Line
                key={key}
                type="monotone"
                dataKey={key}
                stroke={DASHBOARD_COLORS[index % DASHBOARD_COLORS.length]}
                strokeWidth={3}
                dot={false}
                activeDot={{ r: 5 }}
                strokeLinecap="round"
                strokeLinejoin="round"
                filter="url(#lineShadow)"   // 🔥 ADD THIS
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}


// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   Tooltip,
//   ResponsiveContainer,
//   CartesianGrid,
//   Legend,
// } from "recharts";

// const CustomTooltip = ({ active, payload, label }) => {
//   if (active && payload?.length) {
//     return (
//       <div className="bg-slate-800 text-white text-xs rounded-lg px-3 py-2 shadow-xl">
//         <p className="font-semibold mb-1">{label}</p>
//         {payload.map((p, i) => (
//           <p key={i} className="text-blue-300">
//             {p.name}: {p.value}
//           </p>
//         ))}
//       </div>
//     );
//   }
//   return null;
// };

// export default function ProductWarrantyChart({ data }) {

//     const productKeys = Array.from(
//         new Set(
//             data.flatMap((item) =>
//             Object.keys(item).filter((key) => key !== "date")
//             )
//         )
//         );

//     const DASHBOARD_COLORS = [
//       "#22d3ee", // cyan (onboarding)
//       "#a78bfa", // purple (customers)
//       "#34d399", // green (sales)
//       "#60a5fa", // light blue (extra)
//       "#f472b6", // pink (extra)
//     ];
        
//   return (
//     <div className="bg-white rounded-2xl p-5 shadow-sm border border-slate-100">
//       <div className="mb-3">
//         <h3 className="text-sm font-semibold text-slate-800">
//           Product Warranty Sales
//         </h3>
//         <p className="text-[11px] text-slate-400">
//           Product-wise warranty sales trend
//         </p>
//       </div>

//       <div style={{ height: 250 }}>
//         <ResponsiveContainer width="100%" height="100%">
//           <LineChart data={data}>
//             <CartesianGrid stroke="#f1f5f9" vertical={false} />

//             <XAxis
//               dataKey="date"
//               tick={{ fontSize: 10 }}
//             />

//             <YAxis
//               tick={{ fontSize: 10 }}
//               allowDecimals={false}
//             />

//             <Tooltip content={<CustomTooltip />} />
//             <Legend />

//             {/* 🔥 Multiple product lines */}
//            {productKeys.map((key, index) => (
//                 <Line
//                     key={key}
//                     type="monotone"
//                     dataKey={key}
//                     stroke={DASHBOARD_COLORS[index % DASHBOARD_COLORS.length]}
//                     strokeWidth={2}
//                     dot={false}
//                 />
//                 ))}
//           </LineChart>
//         </ResponsiveContainer>
//       </div>
//     </div>
//   );
// }